import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function AboutUs() {
  const navigate = useNavigate();
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="min-h-screen bg-white text-gray-900">
      <div className="max-w-4xl mx-auto px-6 py-16">
        <button onClick={() => navigate(-1)} className="mb-8 text-indigo-600 hover:text-indigo-800 font-medium flex items-center gap-2">
          ← Volver
        </button>
        <h1 className="text-4xl font-bold mb-2">About Us</h1>
        <p className="text-gray-500 mb-10">AdPulse AI — Marketing Analytics Platform</p>

        <div className="prose prose-gray max-w-none space-y-8">
          <section>
            <h2 className="text-2xl font-semibold mb-3">Our Mission</h2>
            <p className="text-gray-600 leading-relaxed">AdPulse AI is a marketing analytics and reporting SaaS platform built for digital marketing agencies and advertisers. We help teams consolidate advertising data from multiple channels — Meta Ads, Google Ads, Google Analytics 4, and Search Console — into unified, actionable dashboards.</p>
            <p className="text-gray-600 leading-relaxed mt-3">Our platform provides automated campaign scoring, performance ranking, and AI-powered insights so marketing professionals can make data-driven decisions faster and optimize their ad spend across all platforms.</p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-3">What We Do</h2>
            <ul className="list-disc pl-6 space-y-2 text-gray-600">
              <li><strong>Multi-platform Dashboard:</strong> Real-time and historical data from Meta Ads, Google Ads, GA4, and Search Console in one place.</li>
              <li><strong>Campaign Scoring:</strong> Automated performance scoring (0-100) with actionable recommendations for each campaign.</li>
              <li><strong>Cross-platform Comparison:</strong> Compare Meta Ads vs Google Ads performance side by side.</li>
              <li><strong>AI-powered Analysis:</strong> Intelligent insights and optimization suggestions powered by AI.</li>
              <li><strong>Automated Reports:</strong> Generate and schedule marketing reports for your clients.</li>
              <li><strong>Multi-client Management:</strong> Manage multiple advertising accounts from a single dashboard.</li>
              <li><strong>Chrome Extension:</strong> Quick access to campaign metrics directly from your browser.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-3">Platform Integrations</h2>
            <ul className="list-disc pl-6 space-y-2 text-gray-600">
              <li><strong>Meta Ads (Facebook & Instagram):</strong> Campaign metrics, spend, impressions, clicks, CTR, conversions, reach, and frequency.</li>
              <li><strong>Google Ads:</strong> Campaign reporting and performance data (read-only). No campaign creation or modification.</li>
              <li><strong>Google Analytics 4:</strong> Sessions, users, pageviews, bounce rate, conversions, and session duration.</li>
              <li><strong>Google Search Console:</strong> SEO clicks, impressions, CTR, and average position.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-3">Our Company</h2>
            <p className="text-gray-600 leading-relaxed">AdPulse AI is developed and operated by a team of marketing technology professionals based in Chile, focused on building tools that transform raw advertising data into clear business decisions.</p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-3">Contact & Address</h2>
            <div className="text-gray-600 space-y-2">
              <p>📍 Lago Bertrand 115, Piso 1024, Quilpué, Región de Valparaíso, Chile</p>
              <p>📧 <a href="mailto:soporte@adpulseia.com" className="text-indigo-600 hover:underline">soporte@adpulseia.com</a></p>
              <p>📞 +56 9 4053 1363 (Chile)</p>
              <p>📞 +34 671 679 251 (España)</p>
              <p>🌐 <a href="https://adpulseia.com" className="text-indigo-600 hover:underline">adpulseia.com</a></p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}
